<template>
  <div>
    <!-- 我的船舶  新增 编辑-->
    <el-row>
      <el-col :span="24">
        <el-form
          :model="ruleForm"
          :inline="true"
          :rules="rules"
          ref="ruleForm"
          label-width="180px"
        >
          <el-form-item label="基地:" prop="companyCode">
            <el-select
              :disabled="disab"
              v-model="ruleForm.companyCode"
              clearable
              placeholder="全部"
              class="w_180"
            >
              <el-option
                clearable
                v-for="(item, index) in base"
                :value="item.companySeq"
                :label="item.chineseName"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="船名:" prop="shipName">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.shipName"
              placeholder="请输入"
              maxlength="18"
              clearable
              @blur="idBlur('driverIdCard')"
            ></el-input>
          </el-form-item>
          <el-form-item label="船号:" prop="shipNum">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.shipNum"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="船长:" prop="shipLength">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.shipLength"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="船高:" prop="shipHigh">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.shipHigh"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="船宽:" prop="shipWide">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.shipWide"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="船舶类型:" prop="shipType">
            <el-select
              :disabled="disab"
              v-model="ruleForm.shipType"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="(item, index) in shipTypeList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="船舶所属公司:" prop="belongCompany">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.belongCompany"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="适航证书有效期至:" prop="airworthinessTime">
            <el-date-picker
              :disabled="disab"
              v-model="ruleForm.airworthinessTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="适合装载证书有效期至:" prop="loadLicenseTime">
            <el-date-picker
              v-model="ruleForm.loadLicenseTime"
              type="date"
              placeholder="选择日期"
              value-format="yyyyMMdd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="适合装载品种:" prop="loadType">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.loadType"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="核定载重量:" prop="loadWeight">
            <el-input
              :disabled="disab"
              v-model.trim="ruleForm.loadWeight"
              placeholder="请输入"
              clearable
            ></el-input>
          </el-form-item>
          <el-col :span="24">
            <el-form-item
              label="船附件:"
              prop="shipEnclosure"
              v-model="ruleForm.shipEnclosure"
            >
              <el-upload
                :disabled="disab"
                class="avatar-uploader"
                :action="upload"
                :show-file-list="false"
                :on-success="getLicenseUrlXs"
                ref="uploadllalal"
                :before-upload="onlyImages"
              >
                <img
                  v-if="ruleForm.shipEnclosure"
                  :src="ruleForm.shipEnclosure"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="el-upload__tip">
                只能上传jpg/png文件，且不超过10Mb
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label=" ">
              <el-button type="primary" @click="submit">保存</el-button>
              <el-button type="primary" @click="$router.back()">返回</el-button>
            </el-form-item>
          </el-col>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<!-- https://hgb-pre.oss-cn-shanghai.aliyuncs.com/9b24e5d474ac420688b6a19377fb8e3e.jpg?Expires=4870998539&OSSAccessKeyId=LTAI8AFW8As2Irmu&Signature=2WQLMW2Ktrng%2Bq5wExhLEAXTHWY%3D -->
<script>
import { baseGateway } from "@/api/base";
import { shipTypeList } from "./columns";
export default {
  props: {
    // 是否承运商
    isCarrier: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      shipTypeList,
      base: [],

      upload: `${baseGateway()}/chem-gateway/chem-loms/file/upload`,
      ruleForm: {
        airworthinessTime: "", //适航证书有效期至
        belongCompany: "", //船舶所属公司
        companyCode: "", //属地代码
        loadLicenseTime: "", //适合装载证书有效期至
        loadType: "", //适合装载品种
        loadWeight: "", //核定载重量
        shipEnclosure: "", //船附件
        shipHigh: "", //船高
        shipLength: "", //船长
        shipName: "", //船名
        shipNum: "", //船号
        shipType: "", //船舶类型
        shipWide: "", //船宽
      },
      // 常用车辆校验
      rules: {
        airworthinessTime: [
          {
            required: true,
            message: "请输入适航证书有效期",
            trigger: "change",
          },
        ],
        belongCompany: [
          { required: true, message: "请输入船舶所属公司", trigger: "blur" },
        ],
        companyCode: [
          { required: true, message: "请输入属地代码", trigger: "change" },
        ],
        loadLicenseTime: [
          {
            required: true,
            message: "请输入适合装载证书有效期",
            trigger: "change",
          },
        ],
        loadType: [
          { required: true, message: "请输入适合装载品种", trigger: "blur" },
        ],
        loadWeight: [
          { required: true, message: "请输入荷载量", trigger: "blur" },
        ],
        shipEnclosure: [
          { required: true, message: "请输入船附件", trigger: "blur" },
        ],
        shipHigh: [{ required: true, message: "请输入船高", trigger: "blur" }],
        shipLength: [
          { required: true, message: "请输入船长", trigger: "blur" },
        ],
        shipName: [{ required: true, message: "请输入船名", trigger: "blur" }],
        shipNum: [{ required: true, message: "请输入船号", trigger: "blur" }],
        shipType: [
          { required: true, message: "请输入船舶类型", trigger: "blur" },
        ],
        shipWide: [{ required: true, message: "请输入船宽", trigger: "blur" }],
      },

      disab: false,
      offSwitch: false, //环保备案开关
    };
  },
  async mounted() {
    await this.getCompanyBase();
    if (this.$route.query.id) {
      this.$api.carrier
        .getDetailCommonVessel(this.$route.query.id)
        .then((res) => {
          for (let key in this.ruleForm) {
            this.ruleForm[key] = res.data[key];
          }
          this.disab = false;
        });
    } else {
      this.disab = false;
    }
  },
  methods: {
    // 提交
    submit() {
      this.$refs.ruleForm.validate((boo) => {
        if (boo) {
          
          let paramsData = { ...this.ruleForm };
          if(this.$route.query.id){
            paramsData.id = this.$route.query.id
          }
          this.$api.carrier.postAddCommonVessel(paramsData).then((res) => {
            // console.log(res,'新增、编辑常用车辆')
            if (res.status == 200) {
              this.$message.success(res.data);
              this.$router.back();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },

    // 上传成功   行驶证URL
    getLicenseUrlXs(response, file, fileList) {
      // console.log(response);
      if (response.status == 200) {
        this.ruleForm.shipEnclosure = response.data;
        this.$refs.ruleForm.clearValidate("shipEnclosure");
      } else {
        this.$message.error("上传失败");
      }
    },

    //只能上传图片
    onlyImages(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"; //image/png
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isJPG) {
        this.$message.error("只能上传文件格式为jpeg,png的!");
      } else if (!isLt2M) {
        this.$message.error("上传图片大小不能超过10MB!");
      } else {
        this.$message({
          message: "正在上传中...",
          type: "info",
          duration: 2000,
        });
        // this.$message.info('正在上传文件中');
      }
      return isJPG && isLt2M;
    },
    //获取基地列表
    async getCompanyBase() {
      await this.$api.user.selectCompanyBase().then((res) => {
        // console.log(res,'获取基地列表')
        if (res.data.length > 0) {
          this.base = res.data;
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-upload__tip {
  line-height: initial;
  margin-top: 0;
}
</style>
